<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><a id="page_5"></a>This book is dedicated to the kids in my life—<br/>my little mortality markers,<br/>Alex and Chelsea.<br/>Now you two are getting old enough to hear<br/>my really <em>good</em> spooky stories.</p>
<p class="dedication1">Special thanks to Adrien for the insight and determined patience, and to Jym for the constant motivation. Thanks also to Dad, Donna, Mom, Aunt Wanda, Jan Haluska, Wilma McClarty, and Eileen Meagher—who knew it all along.</p>
<p class="dedication2">Yet another round of public appreciation goes to some new friends and colleagues, without whom this edition would have never seen the light of day. Unending thanks to my agent, Lantz Powell, for defending me against the mad pirate; to my editor, the indefatigable Liz Gorinsky, for always being on my side; and to Warren Ellis, for giving me a remarkable chance.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?4ba12e55